import { render, staticRenderFns } from "./PassHelp.vue?vue&type=template&id=3e56756c&scoped=true&"
import script from "./PassHelp.vue?vue&type=script&lang=js&"
export * from "./PassHelp.vue?vue&type=script&lang=js&"
import style0 from "./PassHelp.vue?vue&type=style&index=0&id=3e56756c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e56756c",
  null
  
)

export default component.exports